import React from 'react';
import {
  Box,
  Card, CardContent, createStyles,
  makeStyles,
  Typography,
} from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import scan from '../../assets/icons/scan.svg';
import type { IRepairCardProps } from './EstimatorInterfaces';

const useStyles = makeStyles(() => createStyles({
  estimatorCard: {
    height: '100%',
  },
  estimatorSvg: {
    height: 24,
    width: 24,
    marginBottom: 7,
  },
}));

const EstimatorRepairCard: React.FC<IRepairCardProps> = (
  { barcode, isHighPriority },
) => {
  const classes = useStyles();

  return (
    <Card className={classes.estimatorCard}>
      <CardContent>
        <img src={scan} alt="scan.svg" className={classes.estimatorSvg} />
        <Typography>{'Current Barcode'}</Typography>
        <Typography variant="h4" className="verticalCenter">
          <Box component="span" mr={1}>{barcode}</Box>
          {isHighPriority && <ErrorIcon color="error" fontSize="medium" />}
        </Typography>
        <Typography variant="caption" color="textSecondary">{'Barcode Number'}</Typography>
      </CardContent>
    </Card>
  );
};

export default EstimatorRepairCard;
